var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "linkForm",
          attrs: {
            inline: "",
            model: _vm.form,
            size: "small",
            rules: _vm.rules,
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("panel.link_share") } },
            [
              _c("el-switch", {
                staticStyle: { width: "370px" },
                attrs: { "active-value": true, "inactive-value": false },
                on: { change: _vm.onChange },
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c(
                "el-link",
                {
                  staticClass: "de-link",
                  staticStyle: { width: "370px" },
                  attrs: { disabled: "" },
                },
                [_vm._v(_vm._s(_vm.$t("panel.link_share_desc")))]
              ),
            ],
            1
          ),
          _vm.valid
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("panel.link") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "370px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.uri,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "uri", _vm._n($$v))
                      },
                      expression: "form.uri",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.valid
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("panel.over_time"), prop: "overTime" },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: _vm.$t("commons.date.select_date_time"),
                      align: "right",
                      "value-format": "timestamp",
                      "picker-options": _vm.pickerOptions,
                      "default-time": "23:59:59",
                      "popper-class": "link-date-picker-class",
                    },
                    on: { change: _vm.resetOverTime },
                    model: {
                      value: _vm.form.overTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "overTime", $$v)
                      },
                      expression: "form.overTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.valid
            ? _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.resetEnablePwd },
                      model: {
                        value: _vm.form.enablePwd,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enablePwd", $$v)
                        },
                        expression: "form.enablePwd",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("panel.passwd_protect")) + " ")]
                  ),
                  _vm.form.enablePwd
                    ? _c("span", { staticClass: "de-span" }, [
                        _vm._v(_vm._s(_vm.form.pwd)),
                      ])
                    : _vm._e(),
                  _vm.form.enablePwd
                    ? _c(
                        "span",
                        { staticClass: "de-span", on: { click: _vm.resetPwd } },
                        [
                          _c(
                            "el-link",
                            { attrs: { underline: false, type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("commons.reset")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.valid
            ? _c("div", { staticClass: "auth-root-class" }, [
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    !_vm.form.enablePwd
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:copy",
                                value: _vm.form.uri,
                                expression: "form.uri",
                                arg: "copy",
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:success",
                                value: _vm.onCopy,
                                expression: "onCopy",
                                arg: "success",
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:error",
                                value: _vm.onError,
                                expression: "onError",
                                arg: "error",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                          },
                          [_vm._v(_vm._s(_vm.$t("panel.copy_link")))]
                        )
                      : _vm._e(),
                    _vm.form.enablePwd
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:copy",
                                value:
                                  _vm.form.uri + " Password: " + _vm.form.pwd,
                                expression:
                                  "form.uri + ' Password: '+ form.pwd",
                                arg: "copy",
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:success",
                                value: _vm.onCopy,
                                expression: "onCopy",
                                arg: "success",
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:error",
                                value: _vm.onError,
                                expression: "onError",
                                arg: "error",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("panel.copy_link_passwd"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }